import { render, staticRenderFns } from "./Specification.vue?vue&type=template&id=68d17085&"
import script from "./Specification.vue?vue&type=script&lang=js&"
export * from "./Specification.vue?vue&type=script&lang=js&"
import style0 from "./Specification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports